import { NavLink, useLocation } from 'react-router-dom';
import type { User } from '../../types';

const farmerMenu = [
  { path: '/nong-ho/tong-quan', label: 'Tổng quan nông hộ', shortLabel: 'Tổng quan', icon: 'ri-dashboard-line', testId: 'nav-farmer-overview' },
  { path: '/nong-ho/nhat-ky', label: 'Nhật ký canh tác', shortLabel: 'Nhật ký', icon: 'ri-file-list-line', testId: 'nav-farmer-log' },
  { path: '/nong-ho/vay-von', label: 'Quản lý khoản vay', shortLabel: 'Khoản vay', icon: 'ri-hand-coin-line', testId: 'nav-farmer-loan' },
  { path: '/nong-ho/han-muc', label: 'Hạn mức & hợp đồng', shortLabel: 'Hạn mức', icon: 'ri-scales-3-line', testId: 'nav-farmer-limit' },
  { path: '/nong-ho/vat-tu', label: 'Sử dụng vật tư', shortLabel: 'Vật tư', icon: 'ri-seedling-line', testId: 'nav-farmer-material' },
];

const htxMenu = [
  { path: '/htx/tong-quan', label: 'Tổng quan HTX', shortLabel: 'Tổng quan', icon: 'ri-dashboard-line', testId: 'nav-overview' },
  { path: '/htx/nong-ho', label: 'Quản lý nông hộ', shortLabel: 'Nông hộ', icon: 'ri-team-line', testId: 'nav-farmer' },
  { path: '/htx/thu-hoach', label: 'Quản lý thu hoạch', shortLabel: 'Thu hoạch', icon: 'ri-shopping-basket-line', testId: 'nav-harvest' },
  { path: '/htx/hop-dong', label: 'Quản lý hợp đồng', shortLabel: 'Hợp đồng', icon: 'ri-draft-line', testId: 'nav-contract' },
  { path: '/htx/vay-han-muc', label: 'Vay & Hạn mức', shortLabel: 'Vay & HM', icon: 'ri-scales-3-line', testId: 'nav-loan-limit' },
  { path: '/htx/cung-ung', label: 'Quản lý cung ứng', shortLabel: 'Cung ứng', icon: 'ri-truck-line', testId: 'nav-supply' },
  { path: '/htx/tai-chinh', label: 'Quản lý tài chính', shortLabel: 'Tài chính', icon: 'ri-money-dollar-circle-line', testId: 'nav-finance' },
];

interface SidebarProps {
  user: User;
  onLogout: () => void;
  collapsed?: boolean;
}

export function Sidebar({ user, onLogout, collapsed = false }: SidebarProps) {
  const location = useLocation();
  const items = user.role === 'Nông hộ' ? farmerMenu : htxMenu;

  return (
    <aside className={`hidden lg:flex flex-col bg-gradient-to-b from-agrida-800 to-agrida-900 text-white h-screen sticky top-0 shrink-0 transition-all duration-300 ${
      collapsed ? 'w-16' : 'w-56'
    }`}>
      {/* Brand */}
      <div className="h-14 flex items-center px-4 border-b border-white/10 shrink-0">
        <span className="w-8 h-8 flex items-center justify-center shrink-0">
          <i className="ri-plant-line text-xl" />
        </span>
        {!collapsed && <span className="ml-2.5 font-bold text-base whitespace-nowrap">Agrida</span>}
      </div>

      {/* Nav items */}
      <nav className="flex-1 py-3 overflow-y-auto overscroll-contain">
        {items.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={item.testId}
              className={`flex items-center px-3 py-2.5 mx-2 rounded-xl transition-colors ${
                isActive
                  ? 'bg-white/15 text-white'
                  : 'text-white/60 hover:bg-white/8 hover:text-white/90'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-lg`} />
              </span>
              {!collapsed && (
                <span className="ml-3 text-sm font-medium whitespace-nowrap truncate">
                  {item.label}
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* User info + logout */}
      <div className="p-3 border-t border-white/10 shrink-0">
        <div className="flex items-center gap-2.5 mb-2.5">
          <div className="w-8 h-8 rounded-full bg-white/15 flex items-center justify-center shrink-0">
            <i className="ri-user-3-line text-sm" />
          </div>
          {!collapsed && (
            <div className="min-w-0">
              <p className="text-xs font-medium truncate">{user.displayName}</p>
              <p className="text-[10px] text-white/50 truncate">{user.role}</p>
            </div>
          )}
        </div>
        <button
          type="button"
          onClick={onLogout}
          className="flex items-center gap-2 w-full px-2.5 py-2 rounded-xl text-xs text-white/50 hover:bg-white/8 hover:text-white/80 transition-colors whitespace-nowrap min-h-[40px]"
        >
          <span className="w-4 h-4 flex items-center justify-center shrink-0">
            <i className="ri-logout-box-r-line" />
          </span>
          {!collapsed && <span>Đăng xuất</span>}
        </button>
      </div>
    </aside>
  );
}
